import Button from '@components/elements/button/button';
import Modal from '@components/elements/modal/modal';
import { isSome } from '@crocodille/common';
import { useTranslation } from 'next-i18next';
import { useEffect, useState } from 'react';

import styles from './alert.module.scss';

const listeners = new Set<(message: string, title?: string) => void>();

const dispatch = (message: string, title?: string) => {
  listeners.forEach((listener) => listener(message, title));
};

const subscribe = (listener: (message: string, title?: string) => void) => {
  listeners.add(listener);

  return () => void listeners.delete(listener);
};

export function useAlert() {
  return dispatch;
}

export function Alert() {
  const [info, setInfo] = useState<{
    message: string;
    title?: string;
  } | null>(null);

  useEffect(() => {
    const unsubscribe = subscribe((m, t) => {
      setInfo({ message: m, title: t });
    });

    return unsubscribe;
  }, []);

  const { t } = useTranslation();

  return (
    <Modal
      title={info?.title ?? info?.message ?? ''}
      width="auto"
      open={isSome(info)}
      onClose={() => setInfo(null)}
    >
      <p className={styles.message}>{info?.message}</p>
      <Button className={styles.button} onClick={() => setInfo(null)}>
        {t('modal.close')}
      </Button>
    </Modal>
  );
}
